import React from "react"
import Img from "./img"
import "./section8.scss"
import {Row,Col} from "antd"
import {
    PhoneFilled,
    ClockCircleFilled,
    WechatFilled,
    QqOutlined,
    EnvironmentFilled
} from '@ant-design/icons';

class Section8 extends React.Component {
    state = {
    }


    componentDidMount() {

    }

    render() {
        return (
           <div className={"contact-panel"}>
               <Row className={"contact"}>
                   <Col xs={24} md={14}>
                       <ul className={"contact-list"}>
                           <li>
                               <PhoneFilled />
                               <div className={"contact-title"}>咨询电话：</div>
                               <div className={"contact-content"}>136&nbsp;9195&nbsp;4610</div>
                               <div className={"contact-sub-content"}>（预约试听工作日10:00-17:00）</div>
                           </li>
                           <li>
                               <ClockCircleFilled />
                               <div className={"contact-title"}>咨询时间：</div>
                               <div className={"contact-content"}>周一至周日</div>
                               <div className={"contact-sub-content"}>（9:00-18:00）</div>
                           </li>
                           <li>
                               <WechatFilled />
                               <div className={"contact-title"}>微信添加：</div>
                               <div className={"contact-content"}>136&nbsp;9195&nbsp;4610</div>
                           </li>
                           <li>
                               <QqOutlined />
                               <div className={"contact-title"}>QQ添加：</div>
                               <div className={"contact-content"}>623043867</div>
                               <div className={"contact-title"} style={{marginLeft:"24px"}}>QQ报名咨询群：</div>
                               <div className={"contact-content"}>927346382</div>
                           </li>
                           <li>
                               <EnvironmentFilled />
                               <div className={"contact-title"}>学校地址：</div>
                               <div className={"contact-content"}>深圳市宝安区松岗街道红星社区佳裕大厦1805室</div>
                           </li>
                       </ul>
                   </Col>
                   <Col xs={24} md={10}>
                        <div className="wx-panel">
                            <div className="wx">
                                <Img src={"https://img.uigreat.com/szpxfer/wx.jpg"} />
                                招生老师微信
                            </div>
                            <div className="wx">
                                <Img src={"https://img.uigreat.com/szpxfer/wx_jh.jpg"} />
                                靳浩老师微信
                            </div>
                        </div>
                   </Col>
               </Row>
           </div>
        )
    }
}
export default Section8

